import React from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Inbox, Zap } from "lucide-react";
import { FORMAL_VOUCHERS } from "./purchaseConfig";

const sel = "mt-1 w-full h-9 rounded-md border border-input bg-transparent px-3 text-sm";

export function VoucherFields({ kind, voucher, setVoucher, ncf, setNcf }) {
  if (kind === "informal") {
    return (
      <div className="md:col-span-2">
        <Label className="overline">Comprobante</Label>
        <div className="mt-1 h-9 flex items-center gap-2 rounded-md border border-input px-3 text-sm bg-muted/40" data-testid="purchase-voucher-e41">
          <Zap className="w-4 h-4 text-primary" /> Compra informal · E41 <span className="text-xs text-muted-foreground">(Amelia lo emite al registrar)</span>
        </div>
      </div>
    );
  }
  const info = FORMAL_VOUCHERS.find((v) => v.value === voucher);
  return (
    <>
      <div>
        <Label className="overline">Comprobante</Label>
        <select className={sel} value={voucher} onChange={(e) => { setVoucher(e.target.value); setNcf(""); }} data-testid="purchase-voucher-type">
          {FORMAL_VOUCHERS.map((v) => <option key={v.value} value={v.value}>{v.label}</option>)}
        </select>
      </div>
      <div>
        <Label className="overline">NCF del suplidor</Label>
        <Input className="mt-1 font-mono uppercase" value={ncf} onChange={(e) => setNcf(e.target.value.toUpperCase())}
          placeholder={info?.electronic ? `${voucher}0000000001` : `${voucher}00000001`} data-testid="purchase-supplier-ncf" />
      </div>
      {info?.electronic && (
        <div className="md:col-span-2 rounded-md border border-sky-300 bg-sky-50 dark:bg-sky-950/30 p-3 text-xs flex gap-2" data-testid="purchase-ecf-notice">
          <Inbox className="w-4 h-4 text-sky-600 shrink-0 mt-0.5" />
          <div>
            Los {voucher} llegan solos a <b>e-CF Recibidos</b>. Si ya llegó, regístralo desde allí.{" "}
            <Link to="/ecf-recibidos" className="text-primary underline font-semibold" data-testid="purchase-go-ecf-recibidos">Ir a e-CF Recibidos</Link>.
            <br />Si lo digitas aquí, Amelia lo enlazará automáticamente cuando llegue (RNC + NCF evitan registrarlo dos veces).
          </div>
        </div>
      )}
    </>
  );
}
